import React from 'react';
import RightNavItem from '../types/RightNavItem';
import TableContents from '../types/TableContents';
import { DocsPageHeaderType, DocsPageRightNavAnchor } from '../../../common';
import styled from 'styled-components';
import DocsPageHeaderComponent from '../../../common/components/DocsPageHeader';
import { History } from 'history';

type RightSideMenuSectionComponentProps =
    {
        tableContents: TableContents,
        history: History,
        rightNavInView: RightNavItem | undefined
    }

const RightSideMenuSectionComponent: React.FunctionComponent<RightSideMenuSectionComponentProps> = ( {
                                                                                                         tableContents,
                                                                                                         history,
                                                                                                         rightNavInView
                                                                                                     } ): JSX.Element =>
{

    const renderRightSideMenu = ( subSection: Array<RightNavItem> ) =>
    {
        return subSection.map( section =>
            {
                return (
                    <DocsPageRightNavAnchor to={section.hashName}
                                            key={section.hashName}
                                            level={section.level}
                                            text={section.displayName}
                                            newWindow={false}
                                            active={section.hashName === history.location.hash}
                                            inViewAnchor={section.hashName === ( rightNavInView && rightNavInView.hashName )}
                    />
                )
            }
        )
    }

    return (
        <RightSideMenuContainerWrapper>
            <TableContents
                type={DocsPageHeaderType.HEADING_3}
                text={'Table of Contents'}
            />
            {renderRightSideMenu( tableContents.rightMenuNavs )}
        </RightSideMenuContainerWrapper>
    )
}

const RightSideMenuContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    
    position: fixed;
    width: 400px;
    max-height: 700px;
    left: 1390px;
    top: 115px;
    overflow-y: auto;
    
    border-left: 3px solid #0CA0F1;
`;


const TableContents = styled( DocsPageHeaderComponent )`
   margin: 7px 0px 5px 8px;
`

export default RightSideMenuSectionComponent;
